<template>
  <div class="content-top-padding" v-cloak>
    <div class="container mb-3 mt-4" style="max-width: 1660px">
      <div class="row d-flex flex-column">
        <div class="col">
          <h3 class="main-theme">{{ $t("title.worldwide") }}</h3>
        </div>
      </div>
    </div>

    <div class="icon d-flex justify-content-center mt-3 map">
      <img src="@/assets/aboutUs/map-c.jpg" v-if="$i18n.locale == 'zh'" />
      <img src="@/assets/aboutUs/map.jpg" v-else />
    </div>

    <div class="container my-4">
      <div class="row pl-4 pl-md-4 pl-lg-0">
        <div class="col-12 col-md-4 col-lg-4 mb-4 mb-lg-0">
          <div class="main-theme h4 d-flex flex-row" v-if="$i18n.locale == 'zh'">
            <span class="mr-2"><img src="@/assets/aboutUs/dot.png"/></span>
            <h3>總辦事處</h3>
          </div>
          <div class="main-theme h4 d-flex flex-row" v-else>
            <span class="mr-2"><img src="@/assets/aboutUs/dot.png"/></span>
            <h3>Head Office</h3>
          </div>
          <div class="text-theme" v-if="$i18n.locale == 'zh'">香港</div>
          <div class="text-theme" v-else>Hong Kong</div>
        </div>
        <div class="col-12 col-md-4 col-lg-4 mb-4 mb-lg-0">
          <div class="main-theme h4 d-flex flex-row" v-if="$i18n.locale == 'zh'">
            <span class="mr-2"><img src="@/assets/aboutUs/dot_red.png"/></span>
            <h3>全球辦事處</h3>
          </div>
          <div class="main-theme h4 d-flex flex-row" v-else>
            <span class="mr-2"><img src="@/assets/aboutUs/dot_red.png"/></span>
            <h3>Worldwide Offices</h3>
          </div>
          <div class="text-theme" v-if="$i18n.locale == 'zh'">
            北京, 廣洲, 上海, 成都, 東京, 首爾, 新加坡 (越南辦事處), 台北, 悉尼, 倫敦, 巴黎,
            法蘭克幅, 洛杉磯, 多倫多, 紐約
          </div>
          <div class="text-theme" v-else>
            Beijing, Guangzhou, Shanghai, Chengdu, Tokyo, Seoul, Singapore (Vietnam representative),
            Taipei, Sydney, London, Paris, Frankfurt, Los Angeles, Toronto, New York
          </div>
        </div>
        <div class="col-12 col-md-4 col-lg-4 mb-4 mb-lg-0">
          <div class="h4 d-flex flex-row" v-if="$i18n.locale == 'zh'">
            <span class="mr-2"><img src="@/assets/aboutUs/dot_black.png"/></span>
            <h3>地區代辦</h3>
          </div>
          <div class="h4 d-flex flex-row" v-else>
            <span class="mr-2"><img src="@/assets/aboutUs/dot_black.png"/></span>
            <h3>Representatives Offices</h3>
          </div>
          <div class="text-theme" v-if="$i18n.locale == 'zh'">
            (只為旅遊業界／傳媒／消費者提供查詢服務)<br />
            新德里, 雅加達, 曼谷, 菲律賓, 馬來西亞, 莫斯科, 杜拜
          </div>
          <div class="text-theme" v-else>
            (For travel/media/consumer enquries only)<br />
            New Delhi, Jakarta, Bangkok, The Philippines, Malaysia, Moscow, Dubai
          </div>
        </div>
      </div>
      <div class="row mb-5">
        <div class="col note text-theme mt-4" v-if="$i18n.locale == 'zh'">
          有關各全球辦事處及地區代辦的地址及聯絡方法，請<a
            href="https://www.discoverhongkong.com/tc/hktb/about/management.html#worldwide-office"
            class="here"
            >按此</a
          >瀏覽。
        </div>
        <div class="col note text-theme mt-4" v-else>
          For the address and contact details of the worldwide offices and representatives, please
          visit
          <a
            href="https://www.discoverhongkong.com/eng/hktb/about/management.html#worldwide-office"
            class="here"
            >www.discoverhongkong.com</a
          >.
        </div>
      </div>

      <div
        class="
          row
          routing
          d-flex
          justify-content-between
          align-items-center
          mb-5
        "
      >
        <div class="col main-theme d-flex flex-row align-items-center">
          <router-link :to="{ name: 'AboutUs' }" class="">
            <img class="mr-2 route-arrow" src="@/assets/01/btn_catalog_arrow_l.svg" />
          </router-link>
          <router-link :to="{ name: 'AboutUs' }" class="">
            {{ $t("title.aboutUs") }}
          </router-link>
        </div>
        <div class="col main-theme d-flex justify-content-end text-right align-items-center">
          <router-link :to="{ name: 'Landing' }" class="">
            {{ $t("title.home") }}
          </router-link>
          <router-link :to="{ name: 'Landing' }" class="">
            <img class="ml-2 route-arrow" src="@/assets/01/btn_catalog_arrow_r.svg" />
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Map",
  metaInfo: {
    title: "Worldwide Offices & Representatives",
    titleTemplate: "%s - HKTB Annual Report 2020/21",
  },
};
</script>

<style lang="scss" scoped>
.h4 {
  margin-left: -19px;
}
.map {
  background-color: #ede9ea;
}
.here {
  color: #e81b29;
}
@media (max-width: 1156px) {
  .map {
    img {
      width: 100%;
    }
  }
}
</style>
